import * as PIXI from "pixi.js";
import { screenWidth, screenHeight } from "./constants";
import { Game } from "./game";

const app = new PIXI.Application({
  width: screenWidth,
  height: screenHeight,
  backgroundColor: 0xa0d8ef,
});
app.stage.sortableChildren = true;

new Game(app.stage, app.ticker, "title").render();

const container = document.getElementById("app");
container?.appendChild(app.view);
